import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function PasswordRecoverySubmittedDialog() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'check'} />}}>
                Password recovery request submitted
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                Our support team will contact you shortly regarding your password recovery request.
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent='secondary' as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
